var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-overlay",
    { attrs: { value: _vm.sharePopup } },
    [
      _c(
        "v-card",
        { staticStyle: { display: "flex" }, attrs: { width: "300" } },
        [
          _c("v-overlay", { attrs: { value: _vm.createLinkLoader } }, [
            _vm.createLinkLoader
              ? _c(
                  "div",
                  { staticClass: "createLink-loader-state" },
                  [
                    _c("v-progress-circular", {
                      staticStyle: { "align-self": "center" },
                      attrs: { indeterminate: "", color: "primary" }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "v-col",
            { staticStyle: { "background-color": "white" } },
            [
              _c("span", { staticClass: "share-profile" }, [
                _vm._v("Share Profile")
              ]),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  attrs: { dark: _vm.darkRadioGroup },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function() {
                        return [
                          _c("div", { staticClass: "chose-format" }, [
                            _vm._v("CHOOSE FORMAT")
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ]),
                  model: {
                    value: _vm.shareOption,
                    callback: function($$v) {
                      _vm.shareOption = $$v
                    },
                    expression: "shareOption"
                  }
                },
                [
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: { value: "permanent", color: "#2196F3" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "share-profile" }, [
                              _vm._v("Permanent Link")
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", {
                staticStyle: { "background-color": "lightgrey" }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bottom-buttons-container" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "bottom-buttons",
                      attrs: { color: "#1A73EB", text: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("shareOptionClicked")
                        }
                      }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "bottom-buttons",
                      attrs: { color: "#1A73EB", text: "" },
                      on: { click: _vm.createShareEverythingLink }
                    },
                    [_vm._v("\n          OK\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }